import { useMemo, useState } from 'react';
import { useLanguages } from '@/hooks/use-languages';
import { useCollectionPlace } from '@/features/collection-place';
import type { InitialDataLanguage, InitialDataStep } from '../types';
import { emptyRecordingDeviceSelection, type RecordingDeviceSelection } from '@/features/recording-device-metadata';

/** Language and sector chosen on the setup screen, and the current step. */
export function useInitialDataSetup() {
  const { activeLanguages, isLoading: isLoadingLanguages } = useLanguages();
  const [language, setLanguageState] = useState('');
  const [sectorId, setSectorIdState] = useState('');
  const [recordingDevice, setRecordingDevice] = useState<RecordingDeviceSelection>(emptyRecordingDeviceSelection);
  const [step, setStep] = useState<InitialDataStep>('setup');
  const collectionPlace = useCollectionPlace();

  const languages: InitialDataLanguage[] = useMemo(
    () =>
      activeLanguages.map((item) => ({
        code: item.code,
        name: item.name,
        displayName: item.displayName || undefined,
      })),
    [activeLanguages],
  );

  const languageName = useMemo(() => {
    const match = languages.find((item) => item.code === language);
    return match?.displayName || match?.name || language;
  }, [languages, language]);

  return {
    languages,
    isLoadingLanguages,
    language,
    languageName,
    sectorId,
    recordingDevice,
    step,
    collectionPlace,
    setLanguage: (code: string) => {
      setLanguageState(code);
      setStep('setup');
    },
    setSectorId: (id: string) => {
      setSectorIdState(id);
      setStep('setup');
    },
    setRecordingDevice,
    setStep,
  };
}
